<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <MensagemAlerta class="row-space" v-if="msgAlerta" :mensagem="msgAlerta" />

    <div class="form-edit-page row-space">
        <div v-if="cdGrupo==1" class="row row-space">
            <div class="form-item">
                <OperadorFrame :initId="idOperadorInicial" v-model:objSelecionado="operadorSelecionado"/>
            </div>
        </div>

        
        <div class="row row-space">
            <div class="form-item">
                <label class="label-caption">Nome/Identificação</label>
                <input type="text" v-model="docAnexo.nmdoc" maxlength="80" v-uppercase />
            </div>
            
            <div class="form-item-char20">
                <label class="label-caption" >Data</label>
                <input type="date" v-model="docAnexo.dtanexo" />
            </div>

            <div class="form-item-char20">
                <label class="label-caption" >Valido Até</label>
                <input type="date" v-model="docAnexo.dtvalidade" />
            </div>
        </div>


        <div class="row row-space">
            <div class="form-item">
                <label class="label-caption">Observações</label>
                <textarea v-model="docAnexo.obspostagem" maxlength="1000" rows="5" style="resize: none;"/>
            </div>
        </div>


        <div class="row row-space">
            <div class="form-item">
                <label class="label-caption">Selecionar Arquivo (PDF ou JPG):</label>
                <input type="file" @change="onFileChange" accept=".pdf,.jpg" />
            </div>
        </div>


        <div class="row-end">
            <button type="button" class="btn-confirm" @click="salvarAnexo">Enviar</button>
            <button type="button" class="btn-cancel" @click="closeForm">Cancelar</button>
        </div>
    </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import { Api } from '@/funcoes/apiExport';
import { criarAnexo } from '@/models/Anexo';
import { Funcoes } from '@/funcoes/utils';
import { globalStore } from '@/globals';
import { Validar } from '@/funcoes/validacoes';
import MensagemAlerta from '@/components/MensagemAlerta.vue';
import OperadorFrame from '@/components/frames/OperadorFrame.vue';

const emit = defineEmits(['close', 'salvo']);
const props = defineProps({
    cdGrupo: {type: Number, default: 0},
    idOperadorInicial: {type: Number, default: 0},
    idTpDoc: {type: Number, default: 0},
    objReferencia: {type: Object}
});
// CDGRUPO 1 > DOCUMENTO VINCULADO A OPERADOR

const arquivoSelecionado = ref(null);

const docAnexo = criarAnexo();
const isLoading = ref(false);
const msgAlerta = ref(null);
const operadorSelecionado = ref(null);

const closeForm = () => {emit('close');}


function lerDados(){
    docAnexo.dtanexo = Funcoes.strDataAtualYMD();
    docAnexo.cdgrupo = props.cdGrupo;
}


function onFileChange(e) {
    const target = e.target;
    const files = target.files;
    if (files && files.length > 0) {
        arquivoSelecionado.value = files[0]
    } else {
        arquivoSelecionado.value = null
    }
}


async function salvarAnexo() {
    try{
        msgAlerta.value = validarDados();
        if (msgAlerta.value) return;
        isLoading.value=true;

        docAnexo.idmunicipio = globalStore.idmunicipio;
        if (props.cdGrupo===1) docAnexo.idoperador = operadorSelecionado.value.id;
        docAnexo.idlogin = globalStore.idlogin;
        docAnexo.cdgrupo = props.cdGrupo;

        const file = arquivoSelecionado.value;
        docAnexo.tipo = file.type === 'application/pdf' ? '0' : '1';
        docAnexo.fname = file.name;
        
        const r = await Api.genericPost('/main/solicitar/upload', docAnexo);

        if (r.bolok==1){
            // INICIO MÉTODO DE ENVIO DO DOCUMENTO PARA S3 CONFORME EXEMPLO CHATGPT

            const idAnexo = r.id;
            const uploadUrl = r.upload_url;
            const method = r.upload_method || 'PUT';


            const resp = await fetch(uploadUrl, {
                method,
                body: file,
                headers: {
                    'Content-Type': file.type || 'application/octet-stream'
                }
            });


            if (!resp.ok) {
                const txt = await resp.text();
                console.error('Erro no PUT S3', resp.status, txt);
                throw new Error('Falha ao enviar o arquivo para o armazenamento.');
            }


            const eTag = resp.headers.get('etag') || '';


            // FIM MÉTODO DE ENVIO DO ANEXO PARA O S3
            const rConf = await Api.genericPut('/cad/anexo', {
                id: idAnexo,
                fsize: file.size,
                fhash: eTag.replace(/"/g, ''),
                storage_status: 1});

            if (rConf.bolok !== 1) throw new Error(rConf.erro);


            let confirmar;
            if (props.flag==3){
                console.log('*** modelo para uso em função conjunta... exemplo deixado para uso futuro')
            } else {confirmar = true}

            if (confirmar){
                emit('close');
                emit('salvo');
            }
        } else {msgAlerta.value=r.erro}
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;
    }finally{isLoading.value=false;}
}

function validarDados(){
    let r;
    if (props.cdGrupo===1){
        r = Validar.id(operadorSelecionado.value);
        if (!r.ok) return "Necessário informar o condutor";
    }

    r = Validar.texto(docAnexo.nmdoc, "Informe Nome/Identificação");
    if (!r.ok) return r.msg;
    
    if (!arquivoSelecionado.value) return 'Necessário anexar algum documento';

    return null;
}

onMounted(lerDados)
</script>


<style scoped>
.analise-table {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.analise-row {
    display: flex;
    align-items: center;
    padding: 8px;
    border: 1px solid #ddd;
    border-radius: 4px;
    transition: background-color .2s;
}

.analise-row.is-selected {
    background-color: #ffecec;
}

.analise-info {
    flex: 1;
    display: flex;
    gap: 16px;
}

.tipo {
    font-weight: bold;
    width: 30px;
}

.nome {
    flex: 1;
    text-align: start;
}

.btn-toggle {
    margin-right: 12px;
    cursor: pointer;
    border: none;
    background: none;
    color: #007bff;
}

.btn-toggle:hover {
    text-decoration: underline;
}

.input-detalhe {
    flex: 2;
    padding: 4px 8px;
    border: 1px solid #ccc;
    border-radius: 4px;
}
</style>
